const getHistoricalButtonText = (historicalMatchesCounter: number): string => {
  if (historicalMatchesCounter === 0) {
    return "No historical testcases match current test configuration";
  }
  if (historicalMatchesCounter === 1) {
    return `${historicalMatchesCounter} historical testcase match the current test configuration`;
  }
  return `${historicalMatchesCounter} historical testcases match the current test configuration`;
};

export default getHistoricalButtonText;
